import styled from "styled-components";

export const RemarkCellWrapper = styled.div`
  position: relative;
  width: 120px;
  min-height: 30px;
  display: flex;
  align-items: center;
  .remark-cell-edit {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;

export const RemarkCellDisplay = styled.div<{ $hidden?: boolean }>`
  width: 100%;
  display: ${({ $hidden }) => ($hidden ? "none" : "flex")};
  align-items: flex-end;
  gap: 4px;
  cursor: pointer;
  .remark-cell-text {
    flex: 1;
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
  }
  .remark-cell-edit-icon {
    flex: none;
  }
`;
